const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const { logError } = require('../../logger');

const BurningHands = function (battleState) {
  this.handle = 'burning_hands';
  this.magic = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.unit;
  };

  this.execute = function (actor, victim, isProc = false) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      const reflected = BattleCalc.rollForReflectMagic(victim);
      const finalActor = reflected ? victim : actor;
      const finalVictim = reflected ? actor : victim;

      const result = this.standardStrike.execute(
        finalActor,
        finalVictim,
        isProc
          ? 60 + actor.level * 3
          : BattleCalc.getEquippedAbility(actor, 'burning_hands').damage
      );
      result.actorId = finalActor.uid;
      result.victimId = finalVictim.uid;
      result.isProc = isProc;
      result.is_reflection = reflected;
      result.abilityHandle = this.handle;
      result.allPieces = battleState.allPieces;

      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'BurningHands',
        func: 'execute',
        actor: JSON.stringify(actor),
        victim: JSON.stringify(victim),
        isProc,
      });

      return { success: false };
    }
  };
};
module.exports = BurningHands;
